import * as loading from './loading';
import * as languages from './languages';

export default {
  ...loading,
  ...languages,
};
